import React from "react";
import Marquee from "react-fast-marquee";
import SectionHeading from "../SectionHeading";
import { TECH_STACK } from "../../data/site";

const Chip = ({ t }) => (
  <div
    data-testid={`tech-${t.slug}`}
    className="mx-3 flex items-center gap-3 px-5 py-4 rounded-2xl bg-white border border-white/10 shadow-lg shadow-black/30 hover:-translate-y-1 transition-transform duration-300 min-w-max"
  >
    <span className="w-8 h-8 grid place-items-center shrink-0">
      <img
        src={t.src || `https://cdn.simpleicons.org/${t.slug}`}
        alt={`${t.name} logo`}
        loading="lazy"
        className="max-w-full max-h-full object-contain"
        onError={(e) => { e.currentTarget.style.display = "none"; }}
      />
    </span>
    <span className="font-head font-semibold text-navy whitespace-nowrap">{t.name}</span>
  </div>
);

export const TechStack = () => {
  const half = Math.ceil(TECH_STACK.length / 2);
  const rowA = TECH_STACK.slice(0, half);
  const rowB = TECH_STACK.slice(half);

  return (
    <section id="tech" data-testid="tech-section" className="relative py-24 md:py-32 bg-navy-deep overflow-hidden">
      <div className="container-x">
        <SectionHeading
          overline="Technology Stack"
          title="Modern tools, mastered"
          subtitle="We build on battle-tested, current technology across cloud, AI, frontend, backend, DevOps and data."
        />
      </div>

      <div className="mt-14 space-y-5">
        <Marquee gradient gradientColor="#040B16" gradientWidth={120} speed={40} pauseOnHover>
          {rowA.map((t) => <Chip key={t.slug} t={t} />)}
        </Marquee>
        <Marquee gradient gradientColor="#040B16" gradientWidth={120} speed={40} direction="right" pauseOnHover>
          {rowB.map((t) => <Chip key={t.slug} t={t} />)}
        </Marquee>
      </div>
    </section>
  );
};

export default TechStack;
